import React from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';

import {
    fetchSocialActionsByObjective,
    fetchSocialAdsByObjective,
    fetchSocialAdSetsByObjective,
    fetchSocialCalloutsByObjective,
    fetchSocialCampaignsByObjective,
    fetchSocialDataByObjective
} from 'services/social/duck';

import { SocialObjectiveDashboardComponent } from 'containers/dashboards/DashboardBaseComponent';
import LeadGenerationModule from 'components/organisms/social/LeadGenerationModule';

class LeadGenerationContainer extends SocialObjectiveDashboardComponent {
    constructor(props, { objective = 'LEAD_GENERATION' } = {}) {
        super(props, objective);
    }

    makeRequestsForData() {
        const entityId = this.getCurrentEntityId();
        const objective = this.getCurrentObjective();
        const payload = this.createPayload(entityId, objective);

        this.props.fetchSocialActionsByObjective(payload);
        this.props.fetchSocialDataByObjective(payload);
        this.props.fetchSocialAdsByObjective(payload);
        this.props.fetchSocialAdSetsByObjective(payload);
        this.props.fetchSocialCalloutsByObjective(payload);
        this.props.fetchSocialCampaignsByObjective(payload);
    }

    render() {
        return (
            <LeadGenerationModule module={this.props.module}
                xAxisLabel={this.props.xAxisLabel}
                backfillBuckets={this.props.backfillBuckets}
                objective={this.getCurrentObjective()}
                layer={this.props.layer}
            />
        );
    }
}

const mapStateToProps = state => ({
    entityMeta: state.entities.meta,
    module: state.social.facebook.objectives.LEAD_GENERATION,
    selectedTimeRange: state.config.selectedTimeRange,
    xAxisLabel: get(state, 'config.timeBuckets.config.xAxisLabel', 'Date'),
    backfillBuckets: get(state, 'config.timeBuckets.config.buckets', [])
});

export default connect(mapStateToProps, {
    fetchSocialActionsByObjective,
    fetchSocialAdsByObjective,
    fetchSocialAdSetsByObjective,
    fetchSocialCalloutsByObjective,
    fetchSocialCampaignsByObjective,
    fetchSocialDataByObjective,
})(LeadGenerationContainer);



// WEBPACK FOOTER //
// ./src/containers/dashboards/social/LeadGenerationContainer.js